
                // Simplee Storefront Widget - Script - Version 0.1
// For questions visit http://support.simplee.best

var simpleeSelectors = {};
var simpleeClasses = {};

var simpleeWidget = (function () {
    function simpleeWidget() {
        simpleeSelectors = {
          sellingPlanGroupContainer: ".simplee-widget__planGroup--container",
          sellingPlanOptionContainer: "#simplee-defaultwidget__options_grid",
          sellingPlanOptionContainerDelivery_chks: "#simplee-defaultwidget__options_delivery_chks",
          sellingPlanOptionContainerBill_chks: "#simplee-defaultwidget__options_bill_chks",
          sellingPlanOptions: ".simplee-widget__sellingPlan-options",
          widget: ".simplee-defaultwidget",
          sellingPlanIdInput: ".simplee-selling-plan-id-input",
          productForm: 'form[action="/cart/add"]',
          variantIdInput: '[name="id"]',
          variantSelector: ["#shappify-variant-id", ".single-option-selector", "select[name=id]", "input[name=id]"],
          pageTemplate: ".simplee-page-template",
          productJson: ".simplee-product-json",
          moneyFormat: ".simplee-money-format",
          sellingPlanOptionName: ".simplee-widget_sellingPlan_option_name",
          perDeliveryPrice: ".price-item",
          perPriceBadge: ".data-subscription-badge",
        };

    simpleeClasses = {
        hidden: "simplee-widget__hidden",
           visible: "simplee-widget__visible",
        };

        this.products = {};
        this.variants = {};
        this.sellingPlanGroups = {};
        this.pageTemplate = "";
        this.productId = {};
    }

simpleeWidget.prototype = Object.assign({}, simpleeWidget.prototype, {
    init: function () {
        this._handleRequired();
    },

   _handleRequired: function(){
       let forms = document.getElementsByTagName('form');
        for(i=0; i<forms.length; i++){
          let action =  forms[i].action;
          if(action.includes("/cart/add")){
//              remove novalidate attribute
              forms[i].removeAttribute("novalidate");
              
               forms[i].addEventListener("submit", function(e) {
//                 alert('form submit');
               
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation(); // Prevents form from submitting
                
                let okayOrNot = true;
                let isErr = false;
                let requireds = document.getElementsByClassName('required');
                for(j=0; j<requireds.length; j++){
                  let fieldType = requireds[j].type;
                  let fieldClass = requireds[j].id;
                  let fieldVal = '';


                  if(fieldType == 'text' || fieldType == 'textarea' || fieldType == 'checkbox'){
                    if(fieldType == 'checkbox'){
                     const cb = requireds[j].checked;
                      fieldVal = (cb) ? 'Yes' : '';
                    }else{
                      fieldVal = requireds[j].value;
                    }
                    if(fieldVal == ''){
                      isErr = true;
                      document.getElementsByClassName(fieldClass)[0].innerHTML = 'This field is required.';
                    } else{
                      document.getElementsByClassName(fieldClass)[0].innerHTML = '';
                    }
                  }
                }
                
//                 alert(isErr);
                if(!isErr){
                  this.submit();
                }
                return false;

                    });
                }
            }
        }
    })

    return simpleeWidget;
    })();

        document.addEventListener("DOMContentLoaded", function () {
            window.Simplee = window.Simplee || {};
            window.Simplee.simpleeWidget = new simpleeWidget();
            window.Simplee.simpleeWidget.init();
        });
            